import request from '@/config/axios'

export const getTicketPage = (params: any) => request.get({ url: '/rental/ticket/page', params })
export const replyTicket = (data: { id: number; reply: string; status?: number }) =>
  request.put({ url: '/rental/ticket/reply', data })
/** 审核工单：注销通过禁用账号；商家入驻/企业租用通过或驳回并通知用户 */
export const auditTicket = (data: { id: number; pass: boolean; remark?: string }) =>
  request.put({ url: '/rental/ticket/audit', data })
/** 重发商家入驻 B 端登录信息（重置临时密码，回复含账号密码） */
export const reissueMerchantLogin = (data: { id: number }) =>
  request.put({ url: '/rental/ticket/reissue-merchant-login', data })
